import { ANALYTICS_HELPER, HISTORY, ROUTE_CONSTANTS } from '../../../utils'
import { useTranslation } from '../../../hooks'

function About() {
	const translate = useTranslation()

	const handleAbout = () => {
		// LOAD GTM EVENT
		ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
			action: ANALYTICS_HELPER.EVENT.NAVIGATION.ABOUT_US.ACTION,
			label: ANALYTICS_HELPER.EVENT.NAVIGATION.ABOUT_US.LABEL,
			properties: {},
		})
		HISTORY.push(ROUTE_CONSTANTS.ABOUT_US)
	}

	return (
		<>
			<div className="dropdown d-flex">
				<i className="icons-icon-about about-us-header d-sm-none" onClick={handleAbout}></i>
				<button className="nav-link about-us-btn d-none d-sm-block" onClick={handleAbout}>
					{translate('GENERAL.ABOUT_US')}
				</button>
			</div>
		</>
	)
}

export default About
